import { createFileRoute } from '@tanstack/react-router'
import { platformUserSearchSchema } from '@/features/filter-platform-users/model/platformUserSearch'
import { PlatformUsersPage } from '@/pages/platform-users/ui/PlatformUsersPage'

export const Route = createFileRoute('/users')({
  validateSearch: platformUserSearchSchema,
  component: PlatformUsersPage,
})
